import Link from 'next/link';

import useTranslations from '@/hooks/useTranslation';
import ArrowLeftIcon from '@/svgs/arrowLeft.svg';

type SearchResultProps = {
  href: string;
  image: string;
  title: string;
  description: string;
};

const SearchResult: React.FC<SearchResultProps> = ({
  href,
  title,
  description,
}) => {
  const { t } = useTranslations('components.header');

  return (
    <Link
      href={href}
      className="w-full flex flex-row justify-between items-center gap-4"
    >
      <div className="flex flex-col flex-1 justify-between items-right gap-1">
        <p className="font-bold text-foreground text-sm w-54 truncate text-ellipsis">
          {title}
        </p>
        <p className="text-foreground text-xs w-54 truncate text-ellipsis">
          {description}
        </p>
      </div>
      <div className="action">
        <p className="text-sm font-normal flex items-center gap-1.5">
          <span>{t('detail')}</span>
          <span className="w-[13px] h-[13px] flex items-center justify-center">
            <ArrowLeftIcon className="stroke-primary" />
          </span>
        </p>
      </div>
    </Link>
  );
};

export default SearchResult;
